module.exports = __webpack_public_path__ + "static/media/hamburger-menu.c6decc21.svg";